<template>
	<div class="user-dashboard">
    <UserMenu />
    <div class="main-panel">
      <TopNav />
		<Outages/>
      <div class="content">
				<div class="row">
					<div class="col-md-12">
						<Alert :type="alertType" :message="alertMessage" v-if="alertShow === true" />
						<div class="card" v-if="asyncDone === false">
							<!-- Show the loader when async operation is going on -->
							<div class="loader"></div>
						</div>
						<div class="main-content" v-if="asyncDone">
							<!-- Card that holds the custoer details update section in sub-categorized design - START -->
							<div class="card">
								<div class="card-header">
									<h4 class="card-title text-center">Edit your account details</h4>
								</div>
								<div class="card-body">
									<!-- color-classes: "nav-pills-primary", "nav-pills-info", "nav-pills-success", "nav-pills-warning","nav-pills-danger" -->
									<ul class="nav nav-pills nav-pills-primary nav-pills-icons justify-content-center mb-2" role="tablist">
										<li class="nav-item">
											<a class="nav-link active" data-toggle="tab" href="#basicDetailsEdit" role="tablist">
												Basic Details
											</a>
										</li>
										<li class="nav-item">
											<a class="nav-link" data-toggle="tab" href="#emailAndPasswordEdit" role="tablist">
												Password & Security
											</a>
										</li>
									</ul>
									<div class="tab-content tab-space tab-subcategories">
										<!-- Panel for the Basic User Details Edit - START -->
										<div class="tab-pane active" id="basicDetailsEdit">
											<BasicUserDetailsUpdate />
										</div>
										<!-- Panel for the Basic User Details Edit - END -->
										<!-- Panel for the Email & Password Edit - START -->
										<div class="tab-pane" id="emailAndPasswordEdit">
											<EmailUpdate />
											<hr>
											<PasswordUpdate />
											<hr>
											<TwoFAUpdate/>
										</div>
										<!-- Panel for the Email & Password Edit - END -->
									</div>
								</div>
							</div>
							<!-- Card that holds the custoer details update section in sub-categorized design - END -->
						</div>
					</div>
				</div>
      </div>
    </div>
	</div>
</template>

<script>
export default {
	name: "userEditProfile",
	components: {
		Alert: () =>
      import(/* webpackChunkName: "alert" */ "../../../components/Alerts.vue"),
		UserMenu: () =>
      import(/* webpackChunkName: "userMenu" */ "../../../components/User/SideMenu.vue"),
    TopNav: () =>
			import(/* webpackChunkName: "topNav" */ "../../../components/TopNav.vue"),
		BasicUserDetailsUpdate: () =>
			import(/* webpackChunkName: "basicUserDetailsSection" */ "../../../components/User/EditProfile/BasicDetailsUpdate.vue"),
		EmailUpdate: () =>
			import(/* webpackChunkName: "emailDetailsSection" */ "../../../components/User/EditProfile/EmailUpdate.vue"),
		PasswordUpdate: () =>
			import(/* webpackChunkName: "passwordDetailsSection" */ "../../../components/User/EditProfile/PasswordUpdate.vue"),
		TwoFAUpdate: () =>
			import(/* webpackChunkName: "passwordDetailsSection" */ "../../../components/User/EditProfile/TwoFAUpdate.vue"),
		Outages: () =>
				import(/* webpackChunkName: "supportTicketsList" */ "../../../components/Helps/OutageBanner.vue")
	},
	computed: {
    asyncDone() {
      return this.$store.getters["async/state"];
    },
    alertType() {
      return this.$store.getters["alert/type"];
    },
    alertMessage() {
      return this.$store.getters["alert/message"];
    },
    alertShow() {
      return this.$store.getters["alert/show"];
		}
	},
	created() {
		if(this.$store.getters["customer/email"] === null) {
			this.$store.dispatch("customer/fetchUser")
		}
	}
}
</script>
